import { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageHeader, Table, Td, PnL, fmt, EmptyState } from "../../components/dashboard/Shared";

export default function Trades() {
  const [tab, setTab] = useState("closed");
  const [trades, setTrades] = useState(null);

  useEffect(() => {
    setTrades(null);
    api.get(`/investor/trades?status=${tab}`).then(({ data }) => setTrades(data)).catch(() => setTrades([]));
  }, [tab]);

  return (
    <div>
      <PageHeader title="Trades" sub="Full trading activity synced from your MT5 account" />
      <div className="flex gap-2 mb-5">
        {["closed", "open"].map((t) => (
          <button key={t} data-testid={`trades-tab-${t}`} onClick={() => setTab(t)}
            className={`px-4 py-1.5 rounded-lg text-sm capitalize transition-colors ${tab === t ? "bg-[#7000FF]/20 text-[#00F0FF] border border-[#7000FF]/40" : "text-gray-400 border border-white/10 hover:text-white"}`}>
            {t} trades
          </button>
        ))}
      </div>
      {!trades ? (
        <div className="skeleton h-96" />
      ) : trades.length === 0 ? (
        <EmptyState title={`No ${tab} trades`} sub="Trades will appear here once your account starts trading." />
      ) : (
        <Table headers={["Symbol", "Type", "Lots", "Open", "Close", "Open Time", "Commission", "P&L"]} testId="trades-table">
          {trades.map((t) => (
            <tr key={t.trade_id} className="border-b border-white/5 hover:bg-white/[0.02]">
              <Td className="tabular text-white">{t.symbol}</Td>
              <Td><span className={t.type === "buy" ? "text-[#00E676]" : "text-[#FF3B30]"}>{t.type.toUpperCase()}</span></Td>
              <Td className="tabular">{fmt(t.volume)}</Td>
              <Td className="tabular">{t.open_price}</Td>
              <Td className="tabular">{t.close_price ?? "—"}</Td>
              <Td className="text-gray-500 text-xs">{String(t.open_time).slice(0, 16).replace("T", " ")}</Td>
              <Td className="tabular text-gray-500">{fmt(t.commission)}</Td>
              <Td><PnL value={t.profit} /></Td>
            </tr>
          ))}
        </Table>
      )}
    </div>
  );
}
